import React from 'react'

import { KnowYourCustomer } from '@zet/customer'

import EnterNameScreenHeader from '../addCustomer/components/EnterNameScreenHeader'

const KnowCustomerScreen = () => {
  return (
    <>
      <EnterNameScreenHeader />
      <KnowYourCustomer />
    </>
  )
}

export { KnowCustomerScreen }
